import { Button } from "antd";


interface InventoryStatusExtraProps {
  onHandleCheckInventory?: () => void;
  date_start: string;
  date_end: string;
  status: string;
}

const getButtonLabel = (status?: string) => {
  const archivoStatuses = ['N/A', 'Finalizado', 'No realizado'];
  return archivoStatuses.includes(status ?? '') ? 'Archivo' : 'Verificar inventario';
};

const InventoryStatusExtra: React.FC<InventoryStatusExtraProps> = ({
  onHandleCheckInventory,
  date_start,
  date_end,
  status,
}) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: 16,
      flexWrap: 'wrap',
    }}
  >
    <span style={{ minWidth: 200}}>
      Se programó verificación de inventario entre la fecha inicial <strong>{date_start}</strong> y la fecha final <strong>{date_end}</strong>.
    </span>
    <span
      style={{
        border: '1px solid #bfbfbf',
        backgroundColor: '#d1d1d1',
        borderRadius: 6,
        fontWeight: 500,
        padding: '8px 8px',
        minWidth: 120,
        textAlign: 'center',
      }}
    >
      Estado: {status}
    </span>
    {typeof onHandleCheckInventory === 'function' && (
      <Button
        style={{
          border: '1px solid #bfbfbf',
          background: '#fff',
          color: '#222',
          borderRadius: 6,
          fontWeight: 500,
          minWidth: 180,
        }}
        onClick={onHandleCheckInventory}
      >
        {getButtonLabel(status)}
      </Button>
    )}
  </div>
);

export default InventoryStatusExtra;